<template>
  <b-container
    id="StdLogin"
    class="bv-example-row"
    fluid
    style="padding: 2rem 0rem"
  >
    <b-row class="justify-content-md-center">
      <p></p>
    </b-row>
    <b-row class="justify-content-md-left">
      <div v-if="memberShow" class="w-100">
        <b-row class="justify-content-md-left">
          <b-col xl="2" md="6" class="side-panel-mobile-padding">
            <div class="form-group frame_title" style="text-align: left">
              產學攜手專班經濟不利助學金系統
            </div>
            <div
              class="form-group frame_title"
              style="text-align: left; color: red"
            >
              {{ inputData.usrData.name }}
            </div>
            <div class="form-group frame_title" style="text-align: left">
              同學，歡迎回來<br />
              目前系統開放時間為<br />
              <span style="text-align: left; color: red">
                {{ Date1 }}分至 {{ Date2 }}分止
              </span>
            </div>

            <ul class="nav nav-pills flex-column side-menu-mobile-padding">
              <li class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-info text-white rounded"
                    @click.prevent="getPersonalInformation()"
                    >個人資料</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>
              <li v-if="NewCaseShow" class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-info text-white rounded"
                    @click.prevent="getAddNewCase()"
                    >新申請</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>
              <li class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-info text-white rounded"
                    @click.prevent="getAllScholarship2()"
                    >瀏覽待審核</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>
              <li class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-info text-white rounded"
                    @click.prevent="getAllScholarship()"
                    >瀏覽歷史</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>

              <li class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-primary text-white rounded"
                    @click.prevent="logout()"
                    >登出</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>
            </ul>
          </b-col>
          <b-col xl="10" md="6">
            <div id="app" class="well" style="padding: 0 1em">
              <div v-if="HistoryShow" class="overflow-auto">
                產學攜手專班經濟不利助學金目前共 {{ total }}筆

                  <div
                    class="dataTables_scrollBody"
                    style="
                      font-size: 14px;
                      position: relative;
                      overflow: auto;
                      max-height: 100%;

                      border-bottom: 1px solid #111;
                      border-top: 1px solid #111;
                    "
                  >
                    <b-table-simple
                      class="ncut-table-menu-striped ncut-table-menu"
                      responsive
                      bgcolor="#FFFFFF"
                    >
                      <b-thead class="ncut-thead-menu">
                        <b-tr>
                          <b-th style="width: 50px; min-width: 1em"
                            >申請案件編號</b-th
                          >
                          <b-th style="width: 50px; min-width: 1em">學年</b-th>
                          <b-th style="width: 50px; min-width: 1em">學期</b-th>
                          <b-th style="min-width: 5em">申請日期</b-th>
                          <b-th style="min-width: 2em">目前狀態</b-th>
                          <b-th style="min-width: 2em">審核日期</b-th>
                          <b-th style="width: 100px; min-width: 10em"
                            >申請證明文件</b-th
                          >
                          <b-th
                            v-if="ApplyShow"
                            style="width: 90px; min-width: 5em"
                            >操作</b-th
                          >
                          <b-th v-else></b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody class="ncut-tbody-menu">
                        <b-tr
                          v-for="(i, index) in queryInfo"
                          :key="i.id"
                          :index="i.id"
                          :name="i.typeName"
                          v-bind:style="{
                            background:
                              selectedRowIndex == index ? headerColor : '',
                          }"
                          @click="selectedRowIndex = index"
                        >
                          <b-td style="text-align: left">
                            {{ i.id }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ i.schyy }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ i.smt }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ getToday(i.applyTime) }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ getIsComplete(i.isComplete, i.reason) }}
                          </b-td>
                          <b-td tyle="text-align: left">
                            {{ getToday(i.updateTime) }}
                          </b-td>

                          <b-td style="text-align: left">
                            <span class="sel-file" v-if="i.rowId2 != null">
                              <a
                                :href="
                                  './WebApi/Common/GetDocumentFile/' + i.rowId2
                                "
                                target="_blank"
                              >
                                <img src="@/assets/images/disk.png" />戶籍謄本
                              </a> </span
                            ><br />
                          </b-td>
                          <b-td
                            v-if="
                              ApplyShow &&
                              (i.isComplete == 0 || i.isComplete == 3)
                            "
                          >
                            <button
                              href="#"
                              @click.prevent="EditCase(i.id)"
                              class="btn btn-outline-danger"
                              type="button"
                              style="font-size: 14px"
                            >
                              修改
                            </button>

                            <button
                              href="#"
                              @click.prevent="remove(i.id)"
                              class="btn btn-outline-danger"
                              type="button"
                              style="font-size: 14px"
                            >
                              刪除
                            </button>
                          </b-td>
                          <b-td v-else></b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
              </div>
            </div>

            <PersonalInformation
              v-if="PIShow"
              @CaseSelect="CaseSelect"
            ></PersonalInformation>
            <AddNewCase
              :id1="user.id1"
              v-if="AddNewCaseShow"
              @CaseSelect="CaseSelect"
            />
            <EditCase :id="eid" v-if="EditCaseShow" @CaseSelect="CaseSelect" />
          </b-col>
        </b-row>
        <b-modal ref="q-modal" hide-footer title="請注意">
          <div class="d-block text-center">
            <h3>是否確認刪除此筆資料</h3>
          </div>
          <b-button
            class="mt-3"
            variant="outline-danger"
            block
            @click="cancalRM"
            >取消刪除</b-button
          >
          <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
            >刪除確認</b-button
          >
        </b-modal>
        <b-modal size="xl" ref="EditEPaper" hide-footer>
          <template #modal-title> 修改首頁公告 </template>
          <EditEPaper
            :id="eid"
            @hideModal="hideModal('EditEPaper')"
          ></EditEPaper>
        </b-modal>
      </div>
    </b-row>
  </b-container>
</template>
<script>
import * as tools from '../tool'
import PersonalInformation from '@/components/PersonalInformationView.vue'
import AddNewCase from '@/components/AddNewCaseView.vue'
import EditCase from '@/components/EditCase.vue'

export default {
  name: 'StdLogin',
  components: {
    PersonalInformation,
    AddNewCase,
    EditCase
  },
  data () {
    return {
      eid: 0,
      Date1: null,
      Date2: null,
      NewCaseShow: false,
      TimeOpenShow: false,
      HistoryShow: true,
      ApplyShow: false,
      PIShow: false,
      AddNewCaseShow: false,
      EditCaseShow: false,
      memberShow: true,
      em: '',
      content: {
        text1: '',
        text2: ''
      },
      user: {
        id1: '',
        id2: '',
        id3: '',
        sysId: 0, // 學生登入
        isLogin: true
      },

      // captchaInfo:{text1:'',text2:'',text3:''},
      confirmData: null,
      captchaInfo: null,
      inputData: null,
      queryInfo: null,
      total: 0,
      total2: 0,
      // inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10
    }
  },
  computed: {
    filteredDocs: function () {
      let data = []

      if (this.queryInfo != null) {
        data = this.queryInfo.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  methods: {
    getTimeSet: function () {
      var vm = this
      this.$http
        .get('./WebApi/EconomicDisadvantage/GetTimeSet/')
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data[0]
            vm.Date1 = vm.getTodayhhmm(vm.inputData2.date1)
            vm.Date2 = vm.getTodayhhmm(vm.inputData2.date2)

            var date1 = new Date(vm.inputData2.date1)
            var date2 = new Date(vm.inputData2.date2)

            // 取得現在的時間
            var now = new Date()

            // 進行比較
            if (now >= date1 && now <= date2) {
              vm.TimeOpenShow = true
            } else {
              vm.TimeOpenShow = false
            }
            vm.confirmAddNewCase()
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },

    CaseSelect (id) {
      if (id == 1) {
        this.closeShow()
        this.memberShow = true
        this.getAllScholarship2()
      } else if (id == 2) {
        this.closeShow()
        this.PIShow = true
        this.getAllScholarship2()
      }
    },

    remove (eid) {
      this.eid = eid
      this.$refs['q-modal'].show()
    },
    cancalRM () {
      this.$refs['q-modal'].hide()
    },

    confirmRM () {
      this.$refs['q-modal'].hide()
      var vm = this
      this.$http
        .get('./WebApi/EconomicDisadvantage/DeleteApplyPDF/'.concat(this.eid))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,刪除成功')
            vm.getAllScholarship2()
          } else {
            tools.showAlert(vm, 'danger', '對不起,刪除失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },
    confirmAddNewCase () {
      if (this.TimeOpenShow == true && this.total2 == 0) this.NewCaseShow = true
      else this.NewCaseShow = false
    },
    getAddNewCase () {
      this.closeShow()
      this.AddNewCaseShow = true
    },
    EditCase (eid) {
      var vm = this
      vm.closeShow()
      vm.EditCaseShow = true
      vm.eid = eid
    },
    getPersonalInformation () {
      this.closeShow()
      this.PIShow = true
    },
    closeShow () {
      this.HistoryShow = false
      this.ApplyShow = false
      this.PIShow = false
      this.EditCaseShow = false
      this.AddNewCaseShow = false
      this.confirmAddNewCase()
    },
    getToday (updateTime) {
      var dd = new Date(updateTime)
      var today = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
      var yyyy = dd.getFullYear()
      return tools.stringFormat('{0}-{1}-{2}', yyyy, mm, today)
    },
    getTodayhhmm (updateTime) {
      var dd = new Date(updateTime)
      var today = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
      var MM = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
      var yyyy = dd.getFullYear()
      var hh = dd.getHours()
      var mm = dd.getMinutes()
      // var ss = d.getSeconds();

      return tools.stringFormat('{0}-{1}-{2} {3}:{4}', yyyy, MM, today, hh, mm)
    },
    getIsComplete (id, reason) {
      var ret
      if (id == 0) ret = '待審核'
      else if (id == 1) ret = '已核准'
      else if (id == 2) {
        ret = '通過財政調查'
      } else if (id == 3) {
        ret = '退回(' + reason + ')'
      } else if (id == 4) {
        ret = '退學'
      } else if (id == 5) {
        ret = '準備撥款'
      } else if (id == 6) {
        ret = '未通過財政調查'
      }

      return ret
    },

    getAllScholarship () {
      this.closeShow()
      this.HistoryShow = true
      var vm = this
      this.$http
        .get(
          './WebApi/EconomicDisadvantage/GetAllScholarship/'.concat(
            vm.inputData.usrData.id
          )
        )
        .then(function (response) {
          if (response.data != null) {
            vm.queryInfo = response.data
            vm.total = response.data.length
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    getAllScholarship2 () {
      this.closeShow()
      this.HistoryShow = true
      var vm = this
      this.$http
        .get(
          './WebApi/EconomicDisadvantage/GetAllScholarship2/'.concat(
            vm.inputData.usrData.id
          )
        )
        .then(function (response) {
          if (response.data != null) {
            vm.queryInfo = response.data
            vm.total = response.data.length
            if (vm.total >= 1 || vm.TimeOpenShow == false) {
              vm.ApplyShow = true
              vm.NewCaseShow = false
            } else {
              vm.NewCaseShow = true
            }
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    getAllScholarship3 () {
      // 判斷每學期申請只有一筆
      var vm = this
      this.$http
        .get(
          './WebApi/EconomicDisadvantage/GetAllScholarship3/'.concat(
            vm.inputData.usrData.id
          )
        )
        .then(function (response) {
          if (response.data != null) {
            vm.total2 = response.data.length
            console.log('vm.total2=', vm.total2)
            vm.confirmAddNewCase()
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    logout () {
      alert('登出成功')
      window.location.reload()
      window.location.replace('/')
    }
  },

  created () {
    console.log('======created StdLoginView =====')
    this.inputData = this.$store.getters.getInputData
    this.getAllScholarship3()
    this.getTimeSet()

    if (this.inputData != null && this.inputData2 != null) {
      // 確保 inputData 和 usrData 存在

      this.user.id1 = this.inputData.usrData.id

      this.getAllScholarship2()

      // 在這裡確保 inputData2 已經被設置
      this.$nextTick(() => {
        if (this.inputData2) {
          this.Date1 = this.getTodayhhmm(this.inputData2.date1)
          this.Date2 = this.getTodayhhmm(this.inputData2.date2)
        }
      })
    }
  },
  mounted () {
    console.log('======mounted StdLoginView  =====')
  }
}
</script>
<style scoped>
</style>
